import SimpleBreadcrumbs from "Components/Shared/SimpleBreadcrumbs";
import { Formik } from "formik";
import { useAsset } from "Hooks/Endpoints";
import { isEmpty } from "lodash";
import React from "react";
import {
  Button,
  Container,
  Divider,
  Form,
  Header,
  Segment,
} from "semantic-ui-react";
import * as yup from "yup";

const validation = yup.object().shape({
  file: yup.mixed().required(),
});

const AssetCreateForm = () => {
  const { createAsset, save, uncreate } = useAsset();

  return (
    <Container fluid>
      <SimpleBreadcrumbs title='Assets' subtitle='Create' onBack={uncreate} />

      <Segment>
        <Header as='h3'>Create Asset</Header>
        <Divider />
        <Formik
          initialValues={createAsset}
          validationSchema={validation}
          onSubmit={(values, actions) => {
            const data = new FormData();
            data.append("file", values.file);
            save(data);
          }}
        >
          {({ errors, setFieldValue, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Segment>
                <label htmlFor='file' className='fileUpload'>
                  Upload file
                </label>
                <input
                  id='file'
                  name='file'
                  type='file'
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    if (event.currentTarget.files) {
                      setFieldValue("file", event.currentTarget.files[0]);
                    }
                  }}
                  className='form-control'
                />
              </Segment>

              <Button primary type='submit' disabled={!isEmpty(errors)}>
                Submit
              </Button>
            </Form>
          )}
        </Formik>
      </Segment>
    </Container>
  );
};

export default AssetCreateForm;
